<ng-container
  ><ngb-accordion
    #acc
    [destroyOnHide]="false"
    activeIds="error-details"
    (panelChange)="beforePanelChange($event)"
    *ngIf="errorDetails"
  >
    <ngb-panel id="error-details">
      <ng-template ngbPanelHeader let-panel>
        <div
          class="accordion-header accordion-header-error"
          (click)="acc.toggle(panel.id)"
          [ngClass]="{ collapsed: !acc.isExpanded(panel.id) }"
        >
          <span class="accordion-title error-details-title">Error Message</span>
          <div class="accordion-button-group">
            <button
              (click)="copyError()"
              nf-icon-button
              class="btn-bare"
              container="body"
              icon="content-copy"
              ngbTooltip="Copy Error"
            ></button>
          </div>
        </div>
      </ng-template>
      <ng-template ngbPanelContent>
        <div *ngIf="errorHeader" style="padding-left: 10px">
          <b>{{ errorHeader }}</b>
        </div>
        <pre>
          {{ errorDetails | json }}
        </pre>
      </ng-template>
    </ngb-panel>
  </ngb-accordion></ng-container
>
